import * as React from "react";
import * as dataJsonsource from "../api/data";
import { TimelineComponent } from "../common/timeline";
import PuffLoader from "react-spinners/PuffLoader";
import 'react-notifications-component/dist/theme.css';
import 'animate.css';
import Box from '@material-ui/core/Box';
import { Divider, makeStyles, Theme, createStyles, Button, CircularProgress, Dialog, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import useAxios from 'axios-hooks';
import axios from 'axios';
import { vodafoneFont, vodafoneColor } from "../api/data";
import Paper from '@material-ui/core/Paper';
import "../styles/vStyles.css";
import { hasNoServerError, ErrorResponseFromAnypoint, appointmentError } from "./dashboardError";
import { ShowNotification } from "../common/ShowNotification";
import { DisplaySlots } from "../common/RadioApointmentGroup";
import { Footercomponent } from "../common/Footer";
import { confirmation } from './confirmation';
import { formatDate as dateFormatter, formatTime as timeFormatter, transition, tealiumDataLayerPush } from "../utility/utility";
import { getSlots } from "../utility/apiService";
import MapView from "../common/MapView";
import EB from '../common/errorBoundary';

// Icons and images

const vodafoneIcon = require("../assets/img/vodafoneIcon.svg");
const cableImage = require("../assets/img/background.png");
const ticketImage = require("../assets/img/ticket.png");
const Transition = transition('Grow');

//#region styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    wrapper: {
      margin: theme.spacing(1),
      position: 'relative', padding: "0px"
    },
    fontSizeTimelineHeaderText: {
      fontSize: "20px",
      '@media (min-width: 300px)': {
        fontSize: "16px",
      }, '@media (min-width: 600px)': {
        fontSize: "20px",
      }
    },

    buttonSuccess: {
      backgroundColor: dataJsonsource.vodafoneColor,
      '&:hover': {
        backgroundColor: dataJsonsource.vodafoneDark,
      },
    },
    textVodafone: {
      fontFamily: vodafoneFont, color: vodafoneColor
    },
    textGreen: {
      fontFamily: vodafoneFont, color: "black"
    },
    buttonProgress: {
      color: dataJsonsource.vodafoneDoneColor,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },

    mainImage: {
      zIndex: 0,
      backgroundColor: "transparent",
      display: "flex",
      minWidth: '100%',
      flexWrap: "wrap",
      margin: "0px", padding: "0px",
      backgroundImage: `url( ${cableImage} )`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      backgroundAttachment: "fixed",
      minHeight: "100%",
    },

    placeholder: { background: '#fff', minWidth: '100%', minHeight: '30%' },

    button: {
      margin: theme.spacing(1), color: 'black', fontFamily: dataJsonsource.vodafoneFont,
      fontWeight: 'bold',
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: dataJsonsource.vodafoneColor, color: 'white'
      }
    },
    swa_flexBoxColumn: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      overflow: "hidden"
    },
    swa_container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px',
      borderRadius: '5px',
      margin: 'auto',
      '& *': {
        marginBottom: '10px'
      },
      '& :last-child': {
        marginBottom: '0px'
      },
    },
    headingRed: {
      color: vodafoneColor,
    },
    headingNormal: {
      fontWeight: 'normal'
    },
    flexItem: {
      margin: '1px auto'
    },
    slot: {
      backgroundColor: 'rgba(192,192,192,0.4)',
      fontSize: '1rem',
      height: 'auto',
      borderRadius: '5px'
    },
    // amend to scss
    flexBoxRow: {
      display: 'flex',
      flexDirection: 'row',
      placeItems: 'center',
      padding: '5px 0px',
      borderRadius: '5px',
      margin: '10px 0',
      boxShadow: '0px 2px 5px 0px lightgray',
      '& *': {
        marginRight: '0px'
      },
      '& :last-child': {
        marginRight: '0px'
      },
    },

    //end  amend to scss
    listImageBg: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '3rem', width: '3rem',
      borderRadius: '100%',
      backgroundColor: 'rgba(192,192,192,0.3)',
      '@media (min-width: 500px)': {
        width: '4rem',
        height: '4rem'
      }
    },
    listImage: {
      height: '2rem',
      width: '2rem',
      '@media (min-width: 500px)': {
        width: '2.5rem',
        height: '2.5rem'
      }
    },
    orderedList: {
      padding: '0'
    },
    margin0: { margin: '0', marginBlockStart: '0', marginBlockEnd: '0' },
    marginRight10: { marginRight: '10px' },
    marginLeft10: { marginLeft: '10px' },
    marginTop10: { marginTop: '10px' },
    marginBottom10: { marginBottom: '10px' },
    padding10: { 'padding': '10px' },
    padding0: { padding: '0' },
    paddingRight10: { 'paddingRight': '10px' },
    paddingLeft10: { 'paddingLeft': '10px' },
    paddingTop10: { 'paddingTop': '10px' },
    paddingBottom10: { 'paddingBottom': '10px' },
    width100: { width: '100%' },
    justifyCenter: { justifyContent: 'center' },
    alignCenter: { alignItems: 'center' },
    noBoxShadow: { boxShadow: 'none' }
  }),
);
//#endregion

// DashboardComponent 
export const DashboardComponent = () => {

  const classes = useStyles();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let uid = params.get('uid');
  if (!uid || uid?.length < 1) { //checking if uid is present
    window.location.assign('https://www.vodafone.de'); //redirecting
  } //end
  const [{ response, loading, error }, refetch] = useAxios({
    method: 'get',
    url: dataJsonsource.getTicketURL(), //middleware address comes here
    headers: {
      'client_secret': process.env.REACT_APP_CI_FOCUS21_FE_SECRET,
      'uid': uid
    },
    data: ''
  });

  //#region states
  const [reopenAvailable, setreopenAvailable] = React.useState(true);
  const [cancelAvailable, setcancelAvailable] = React.useState(true);

  const [dialogState, setdialogState] = React.useState("success");
  const [reopening, setReopening] = React.useState(false);
  const [cancelling, setCancelling] = React.useState(false);

  const [appointable, setAppointable] = React.useState(true);
  const [reappointable, setReappointable] = React.useState(true);
  const [loadedslots, setLoadedslots] = React.useState([]);
  const [showSlots, setShowSlots] = React.useState(false);
  const [showConfirmationPage, setShowConfirmationPage] = React.useState(false);
  const [selectedSlot, setSelectedSlot] = React.useState({});
  const [showAppointmentError, setShowAppointmentError] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [temp, setTemp] = React.useState(0);

  const [openDialogue, setopenDialogue] = React.useState(false);
  const [targetURL, setTargetURL] = React.useState("");
  const [action, setAction] = React.useState("");
  const [dialogContentString, setdialogContentString] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");
  const [failureMessage, setFailureMessage] = React.useState("");
  //#endregion

  React.useEffect(() => {
    if (response && response?.data.hasOwnProperty('woNum')) {
      tealiumDataLayerPush('pageview', {}, {}, { siteStructureElement: ['overview'] }, {})
    }
  }, [response])

  //#region Open Dialog
  function openDialogueBox(url: any, action: any, dialogContentStringInput: any, successMessage: any, failureMessage: any) {
    setAction(action);
    setTargetURL(url);
    setopenDialogue(true);
    setdialogContentString(dialogContentStringInput);
    setSuccessMessage(successMessage);
    setFailureMessage(failureMessage);
    if (action === dataJsonsource.reopenable) {
      tealiumDataLayerPush('layover', {}, { name: 'confirm reopen ticket' }, {}, {}).then();
    } else if (action === dataJsonsource.cancelable) {
      tealiumDataLayerPush('layover', {}, { name: 'confirm cancellation ticket' }, {}, {}).then();
    }
  }
  //#endregion

  //#region Close Dialog
  const closeDialogue = () => {
    setopenDialogue(false);
  };
  //#endregion

  //#region calling middleware
  function CallMiddleware() {
    closeDialogue();
    if (action === dataJsonsource.reopenable) {
      setreopenAvailable(false);
      setcancelAvailable(false);
      setReopening(true);
    }
    else if (action === dataJsonsource.cancelable) {
      setcancelAvailable(false);
      setreopenAvailable(false);
      setCancelling(true);
    }

    axios.get(targetURL, {
      headers: {
        'client_secret': process.env.REACT_APP_CI_FOCUS21_FE_SECRET,
        'uid': uid
      }
    }).then(result => {
      if (result.data.hasOwnProperty('result_code')) {
        setdialogState("error");
        openDialogueBox("", "", "", "", "");
        setreopenAvailable(true);
        setcancelAvailable(true);
        setReopening(false);
        setCancelling(false);
        tealiumDataLayerPush('error', { location: action === dataJsonsource.reopenable ? 'landing page - reopen' : 'landing page - canceling', type: 'technical', message: 'backend error received' }, {}, {}, {}).then();
      }
      else {
        ShowNotification("success", successMessage);
        tealiumDataLayerPush('pageview', {}, {}, { siteStructureElement: action === dataJsonsource.reopenable ? ['overview', 'ticket reopened'] : ['overview', 'ticket cancelled'] }, {}).then();
      }

    }).catch(error => {
      setreopenAvailable(true);
      setcancelAvailable(true);
      setReopening(false);
      setCancelling(false);
      // ShowNotification("danger",failureMessage);
      setdialogState("error");
      openDialogueBox("", "", "", "", "");
      tealiumDataLayerPush('error', { location: action === dataJsonsource.reopenable ? 'landing page - reopen' : 'landing page - canceling', type: 'technical', message: 'backend error received' }, {}, {}, {}).then();
    });
  }
  //#endregion

  //#region React Render

  //#region pre-loader
  if (loading) return (<div className="wa__preloader">

    <div className="wa__utility--tac wa__utility--centerobject">
      <PuffLoader size={150} color={vodafoneColor} />
    </div>
    <br></br><br></br>
    <text style={{ fontFamily: vodafoneFont, color: vodafoneColor, fontSize: "32" }}>
      Einen Moment, deine Anfrage wird bearbeitet.</text>
  </div>)
  // #endregion preloader

  //#region network error handler
  // if (error) return hasNoServerError(vodafoneIcon)
  if ((!response?.data?.hasOwnProperty('woNum') || error) && process.env.NODE_ENV !== 'development') return ErrorResponseFromAnypoint(error?.response, vodafoneIcon);
  //#endregion

  // let timeline = dataJsonsource.getTimeline();  
  //  let timeline = response.data; 
  let timeline = process.env.NODE_ENV === 'development' ? dataJsonsource.getTimeline() : response.data;

  if (showConfirmationPage) {
    return confirmation(classes, setShowConfirmationPage, selectedSlot,
      setShowSlots, { seCompany: timeline.seCompany, sePhone: timeline.sePhone }, refetch)
  }
  return (
    <div className="wa__parentcontainer">
      <Box flexDirection="row" p={1} m={1} justifyContent="left" style={{ minHeight: '2vh' }}>
        <a href="https://www.unitymedia.de">
          <img src={vodafoneIcon} height={"45px"} width={"45px"} />
        </a>
      </Box>
      <Box flexDirection="column" p={1} m={1} style={{ padding: "0px", margin: "0px", minHeight: '90vh' }}>
        <Box className="wa__parentcontainer__overlaybg" bgcolor="background.paper">
          <Box className="wa__utility--flex--center">
            <text className="wa__copy__heading--large">{timeline.workOrderTypeIndicator === 'INSTALL' ? 'Meine Auftragsübersicht' : 'Mein Störungsticket'}</text>
          </Box>

          <Paper elevation={5} variant={"outlined"} square className="wa__utiity--m0auto wa__containerfw--center  wa__utility--mb3">
            <Box className="wa__section__header">
              <text className="wa__section__header--text">
                {timeline.workOrderTypeIndicator === 'INSTALL' ? 'Dein Auftrag' : 'Deine Störungsmeldung'}
              </text>
            </Box>
            <Divider variant="middle"></Divider>

            <div className="wa__section__content">
              <img src={ticketImage} className="wa__section__content__icon" />
              <text className="wa__section__content__text">
                Dein Auftrag {timeline.woNum} ist im Status “{timeline.woStatusText}”
                </text>
            </div>

            {timeline.hasOwnProperty('appointmentStart') === true && timeline.woStatus.toUpperCase() !== 'CLOSED' ?
              (['', undefined, null].indexOf(timeline['appointmentStart']) === -1 ?
                <div className="wa__section__content">
                  <img src={ticketImage} className="wa__section__content__icon" />
                  <text className="wa__section__content__text">
                    Geplanter Termin {dateFormatter(timeline['appointmentStart'])}, {timeFormatter(timeline['appointmentStart'], timeline['appointmentEnd'])}
                  </text>
                </div>
                : null)
              : null}

            <Divider variant="middle"></Divider>
            <EB>
              {timeline.tripStarted && !timeline.workStarted && <MapView
                customerLocation={{ lat: timeline.gpsLat, lng: timeline.gpsLong }}
                technicianLocation={{ lat: timeline.seGpsLat, lng: timeline.seGpsLong }}
                technicianName={(timeline.seLastName === null || timeline.seFirstName === null) ? null : `${timeline.seFirstName} ${timeline.seLastName[0]}.`}
                technicianPhone={timeline.sePhone}
                technicianCompanyname={timeline.seCompany}
                technicianImage={timeline.sePhoto}
                uid={uid}
                eta={timeline.seEta}
                classes={classes}
                street={timeline.street}
                houseNo={timeline.houseNo}
                zip={timeline.zip}
                city={timeline.city}
                country={timeline.country}
                anypointETA={timeline.seEta}
              ></MapView>}
            </EB>

            {/* start ====  display buttons and appointment slots */}
            {[timeline.reopenable, timeline.cancelable, timeline.appointable, timeline.reappointable].indexOf(true) > -1 ?
              <Box className="wa__containerfw  wa__utility--mt1">
                <div className="wa__row">
                  {
                    timeline.reopenable && timeline.workOrderTypeIndicator !== 'INSTALL' ?
                      <div>
                        <div className="wa__button__primary">
                          <Button key={dataJsonsource.reopenable} disabled={!reopenAvailable} variant="contained" className={classes.button} onClick={() =>
                            openDialogueBox(dataJsonsource.reOpentURL(), dataJsonsource.reopenable, dataJsonsource.reOpenDialogString,
                              dataJsonsource.reopenSuccess, dataJsonsource.reopenFailure)}>
                            {"Ticket wieder öffnen"}
                          </Button>
                        </div>
                        {reopening && <CircularProgress size={24} className={classes.buttonProgress} />}
                      </div> : ""
                  }
                  {
                    timeline.cancelable && timeline.workOrderTypeIndicator !== 'INSTALL' ?
                      <div>
                        <div className="wa__button__primary">
                          <Button key={dataJsonsource.cancelable} disabled={!cancelAvailable} variant="contained" className={classes.button} onClick={() =>
                            openDialogueBox(dataJsonsource.cancelURL(), dataJsonsource.cancelable, dataJsonsource.cancelDialogString,
                              dataJsonsource.cancelSuccess, dataJsonsource.cancelFailure)}>
                            {"Ticket stornieren"}
                          </Button>
                        </div>
                        {cancelling && <CircularProgress size={24} className={classes.buttonProgress} />}
                      </div> : ""
                  }
                  {
                    timeline.appointable ?
                      <div>
                        <div className="wa__button__primary" >
                          <Button key={dataJsonsource.appointable} disabled={!appointable} variant="contained" className={classes.button}
                            onClick={() => {
                              tealiumDataLayerPush('pageview', {}, {}, { siteStructureElement: ["technician scheduler", "select date and time"], }, {}).then()
                              setLoader(true);
                              getSlots(uid).then(res => {
                                setTemp(1);
                                setLoader(false);
                                if (res['data'].hasOwnProperty('code') && res['data']['code'] == 0) {
                                  setLoadedslots(res['data']);
                                  setShowSlots(true);
                                } else {
                                  tealiumDataLayerPush('error', { type: 'technical', message: 'backend error received', location: 'landing page - scheduling' }, {}, {}, {}).then();
                                  setShowAppointmentError(true);
                                }
                              }).catch(error => {
                                tealiumDataLayerPush('error', { type: 'technical', message: 'backend error received', location: 'landing page - scheduling' }, {}, {}, {}).then();
                                setLoader(false);
                                setShowAppointmentError(true);
                                setShowSlots(false);
                              })
                            }}>
                            {"Technikertermin planen"}
                          </Button>
                        </div>
                      </div>
                      : ""}


                  {
                    timeline.reappointable ?
                      <div>
                        <div className="wa__button__primary">
                          <Button key={dataJsonsource.reappointable} disabled={!reappointable} variant="contained" className={classes.button}
                            onClick={() => {
                              tealiumDataLayerPush('pageview', {}, {}, { siteStructureElement: ["technician rescheduler", "select date and time"], }, {}).then()
                              setLoader(true);
                              getSlots(uid).then(res => {
                                setTemp(2);
                                setLoader(false);
                                if (res['data'].hasOwnProperty('code') && res['data']['code'] == 0) {
                                  setLoadedslots(res['data']);
                                  setShowSlots(true);
                                } else {
                                  tealiumDataLayerPush('error', { type: 'technical', message: 'backend error received', location: 'landing page - rescheduling' }, {}, {}, {}).then();
                                  setShowAppointmentError(true);
                                }
                              }).catch(error => {
                                tealiumDataLayerPush('error', { type: 'technical', message: 'backend error received', location: 'landing page - rescheduling' }, {}, {}, {}).then();
                                setLoader(false);
                                setShowAppointmentError(true);
                                setShowSlots(false);
                              })
                            }}>
                            {"Technikertemin verschieben"}
                          </Button>
                        </div>
                      </div>
                      : ""}
                </div>

                <div>
                  {loader ?
                    <div className={classes.swa_flexBoxColumn}>
                      <div className={classes.flexBoxRow + ' ' + classes.noBoxShadow} style={{ margin: 'auto' }}>
                        <PuffLoader size={150} color={vodafoneColor} />
                      </div>
                      <text style={{ fontFamily: vodafoneFont, color: vodafoneColor, fontSize: "32", textAlign: 'center' }}>
                        Einen Moment, deine Anfrage wird bearbeitet.</text>
                    </div>
                    : null}
                </div>

                <div className="wa__row">
                  {
                    showSlots && !loader ? <DisplaySlots
                      slotsData={loadedslots}
                      classes={classes}
                      setSelectedSlot={setSelectedSlot}
                      supplierInfo={{
                        seCompany: timeline.seCompany,
                        sePhone: timeline.sePhone,
                        workOrderId: timeline.woNum
                      }}
                      setShowConfirmationPage={setShowConfirmationPage}
                      uid={uid}
                      setShowAppointmentError={setShowAppointmentError}
                      bookingType={temp}
                    /> : null
                  }


                </div>
              </Box> : null}
            {/* end  ====  display buttons and appointment slots */}

            <Divider variant="middle"></Divider>
            {timeline.workOrderTypeIndicator !== 'INSTALL' && <div className="wa__timeline">
              <TimelineComponent timelineProgress={timeline.activities} timelineCreated={""} timelineFinished={""}
                currentStatus={timeline.woStatus} startTime={timeline.creationDate} />
            </div>}

          </Paper>

        </Box>
      </Box>

      {/* footer */}

      <Footercomponent />


      {/* end  footer */}

      <Dialog
        open={openDialogue}
        TransitionComponent={Transition}
        keepMounted
        className={classes.textGreen}
        onClose={closeDialogue}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText className={classes.textGreen} id="alert-dialog-slide-description">
            {dialogState === "error" ?
              <div><p>
                  Hallo Vodafone-Kund:in,
                <br />es tut uns leid, aber bei der Verarbeitung deiner Anfrage auf dieser Webseite ist etwas schiefgegangen.
                <br />Alternativ kannst du auch bequem per Telefon dein Ticket stornieren, wieder öffnen sowie den aktuellen Status abfragen.
                <br />Melde dich unter 0221 4661 9100 und sage bei der Frage nach deinem Anliegen <i>"Störung"</i>.
                <br />Vielen Dank für dein Verständnis.
                <br />Freundliche Grüße
                <br />Dein Vodafone-Team
              </p> </div>
              : dialogContentString
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {dialogState === "success" ?
            <Button onClick={() => {
              closeDialogue()
              tealiumDataLayerPush('pageview', {}, {}, { siteStructureElement: ['overview', action === dataJsonsource.reopenable ? 'ticket reopening aborted' : 'ticket cancellation aborted'] }, {});
            }}
              className={classes.button}>
              Nein
              </Button>
            : ""
          }
          {dialogState === "success" ?
            <Button onClick={() => CallMiddleware()} className={classes.button}>
              Ja
              </Button>
            : ""
          }
          {dialogState === "error" ?
            <Button onClick={() => { closeDialogue(); setdialogState('success') }} className={classes.button}>
              Ok
              </Button>
            : ""
          }
        </DialogActions>
      </Dialog>

      {showAppointmentError ?
        <Dialog
          className={classes.textGreen}
          open={true}
          TransitionComponent={Transition}
          onClose={() => setShowAppointmentError(false)}
          keepMounted
        >
          <DialogContent>
            <DialogContentText className={classes.textGreen} id="alert-dialog-slide-description">
              {appointmentError('standard')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowAppointmentError(false)} className={classes.button}>
              OK
             </Button>
          </DialogActions>
        </Dialog>
        :
        null
      }
    </div>
  );
  //#endregion
};
